import {FLW40} from './flw40';
import {FLW32} from './flw32';
import {FLW28} from './flw28';
import {FLW24} from './flw24';
import {FLL} from './fll';
import {FLM} from './flm';

export * from './fll-uw';

export const productValues = {
	FLW40,
	FLW32,
	FLW28,
	FLW24,
	FLL,
	FLM
};